export default __webpack_public_path__ + "static/media/img-adolescent.1d6dec42.png";